<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size att_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ title }}</i>
                </dt>
                <dd>
                    <!-- Attachment -->
                    <innorix-download
                        v-if="attach.length > 0"
                        :uploadId="uploadId"
                        :serviceType="serviceType"
                        :attachList="attach"
                        :seq="getKnowledgeId"
                    />
                    <!-- //Attachment -->

                    <dl class="attachment_link" v-if="attach.length > 0">
                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                        <dd>
                            <ul>
                                <li v-for="file in attach" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                    </a>
                                </li>
                            </ul>
                        </dd>
                    </dl>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue              from 'vue';
import qs               from 'query-string';
import axios            from 'axios';
import { SDLUtil }      from '@/utils';
import InnorixDownload  from '~c/InnorixDownload';

const fetchAttachList = formData => axios.post( 
    `${SDLUtil.API_URL}/basis/knowledge/knowledgeListAttach.skp`,
    qs.stringify(formData),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'KnowledgeAttachFilePopup',
    props: [ 'title', 'knowledgeId' ],
    data() {
        return {
            uploadId: 'inno_' + this.knowledgeId,
            serviceType: 'common',
            attach: [],
        }
    },
    computed: {
        getKnowledgeId() {
            return this.knowledgeId || '';
        },
    },
    components: {
        'innorix-download'  : InnorixDownload
    },
    methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            if(SDLUtil.isNull(this.getKnowledgeId)) {
                SDLUtil.showLoadingBar(false);
                SDLUtil.alert({
                    title: "TITLE.GLOBAL.POPUP.ALERT",  // Alert
                    msg: "MESSAGE.FILE.NOSELECTFILE",   // No file is choosed.
                    okLabel: "BUTTON.GLOBAL.CLOSE",     // Close
                    onOkEvt : () => { this.$emit('close'); }
                });

            } else {
                const formData = {
                    BOARD_ID: this.getKnowledgeId
                };

                return await fetchAttachList(formData);
            }
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
    },
    created() {
        this.initLoad()
            .then((res) => {
                let attachList = res.data.attach.rowData || [];
                if(attachList.length > 0){
                    Vue.$log.info('KnowledgeAttachFilePopup.vue attachList =>', attachList);
                    this.attach = attachList;
                }

                SDLUtil.showLoadingBar(false);
            });
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeAttachFilePopup.vue